import React, { type ReactElement } from 'react';
import {
	RouterActions as LinkActionsDI,
	RouterSubscriber as LinkListenerDI,
	type RouterActionPush as Push,
	type RouterActionsType,
	type Location,
} from '@atlassian/react-resource-router';

export type PushHistory = Push | undefined;

export type Props = {
	RouterSubscriber: typeof LinkListenerDI;
	RouterActions: typeof LinkActionsDI;
	children: (arg1: { push: PushHistory }) => ReactElement;
};

const pushWithSpaCompatibleUrl =
	(push: RouterActionsType['push'], projectKey: string) => (path: Location | string) => {
		push(
			`/jira/servicedesk/projects/${projectKey}${
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				(path as string).charAt(0) === '/' ? `${path}` : `/${path}`
			}`,
		);
	};

/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */
const KnowledgeHubPushProvider = (props: Props) => {
	const { RouterActions, RouterSubscriber, children } = props;
	return __SPA__ ? (
		<RouterActions>
			{({ push }: RouterActionsType) => (
				<RouterSubscriber>
					{({ match }) =>
						match?.params?.projectKey
							? children({
									push: pushWithSpaCompatibleUrl(push, match.params.projectKey),
								})
							: children({ push: undefined })
					}
				</RouterSubscriber>
			)}
		</RouterActions>
	) : (
		children({ push: undefined })
	);
};

KnowledgeHubPushProvider.defaultProps = {
	RouterActions: LinkActionsDI,
	RouterSubscriber: LinkListenerDI,
};

export default KnowledgeHubPushProvider;
